import { IApplicationState } from '../../types/redux';

export function selectBrokerSelfRequestFormWidgetActive(state: IApplicationState) {
  return state.brokerSelfRequestFormWidget.active;
}
